import { syncHistoryWithStore, routerReducer } from 'react-router-redux'
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { middleware } from '../components/history';
import createSagaMiddleware from 'redux-saga'
import loggingMiddleware from './middleware/logging';
import reducer from '../reducers'

// create the saga middleware
const sagaMiddleware = createSagaMiddleware()
// mount it on the Store

export default (initialState) => {

  return {
    ...createStore(
      reducer,
      // initialState,
      window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
      applyMiddleware(sagaMiddleware, middleware),
    ),
    runSaga: sagaMiddleware.run
  }

}


// WEBPACK FOOTER //
// ./src/store/configureStore.js